export const environment = {
  production: true,
  apiUrl: 'https://api.paquik.ae/api',
  backEndUrl: 'https://api.paquik.ae',
  defaultPaginator: {
    pageSize: 10,
    pageIndex: 0,
  },
  widthDialogIntoSmallWidthDialog: '16rem',
  smallWidthDialog: '18.75rem',
  mediumWidthDialog: '31.25rem',
  largeWidthDialog: '54rem',
  xLargeWidthDialog: '71.25rem',
  mobileSize: '(max-width: 750px)',
};
